import { getPlatform } from "global/utils/platformDetector";
import { IonSpinner } from "@ionic/react";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { detectarIOS } from "global/utils/detectarIOS";
import { useContext, useEffect, useState } from "react";
import MercadoPagoLogo from "_+_Portal/assets/images/generico/MercadoPagoLogo";
import {
  mercadoPagoReset,
  wsGetMercadoPagoLaboratorio,
  wsGetMercadoPagoReferencia,
  wsGetMercadoPagoTurnos,
} from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  Paso4Body,
  Paso4Container,
  Paso4ContainerBotones,
  Paso4ContainerPaso,
  Paso4Titulo,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { proximoPaso } from "../PagesFun";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";

import { setAvisoAutocheck } from "_+_Portal/_-_Autocheckin/context/action/avisoAutocheck";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import {
  wsGetTurnoSaldado,
  wsGetTurnoSaldadoLabo,
} from "_+_Portal/context/Actions/turnos/turnoSaldado";

const AbonarMP = ({ turnoActual }) => {
  //#region --------- context ---------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    rutaDispatch,
    puntoControlDispatch,
    rutaState,
    turnosAutoCheckInDispatch,
    avisoAutocheckDispatch,
    turnosSeleccionadosDispatch,
    turnoSaldadoDispatch,
    pasoState,
  } = useContext(AutocheckContext);
  const { mercadoPagoDispatch, mercadoPagoState, selectDropDownState } =
    useContext(PortalContext);
  const { toasterDispatch, authState } = useContext(GlobalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado?.[turnoActual];

  const bodyTxt =
    "Te falta un paso para finalizar la recepción de tu turno. El valor del mismo es de:";
  const bodyTxt2 =
    "(Seleccioná una opción para abonar. Recordá que por Mercadopago podés abonar con tarjeta de crédito y/o débito)";

  const paciente = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
    : authState?.auth?.data?.paciente;

  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo
    ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido?.paciente
        ?.codigo
    : false;
  const [loadingGral, setLoadingGral] = useState(true);
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(true);
  const [intervalID, setIntervalID] = useState(true);
  // Espera a tener la ref
  const isIOS = detectarIOS();
  const deviceType = getPlatform();
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const nextStepMercadoPago = (isCorrect, data) => {
    if (isCorrect) {
      setLoading(true);
    } else {
      showToaster(
        {
          texto: "Hubo un error.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      const idTipoPuntoControl = 8;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  };
  const handleClickMP = () => {
    if (mercadoPagoState.mercadoPago.data) {
      setInitial(false);
      let interval;
      interval = loopTurnoSaldado();
      setIntervalID(interval);
      try {
        const idWebservice = JSON.parse(
          mercadoPagoState.mercadoPago.data.idWebservice,
        );
        if (isIOS) {
          if (deviceType !== "web") {
            window.location.href = idWebservice.initPoint;
          } else {
            window.open(idWebservice.initPoint, "_blank");
          }
        } else {
          window.open(idWebservice.initPoint, "_blank");
        }
      } catch (e) {
        console.error("Error parsing idWebservice:", e);
      }
    } else {
      if (turno?.idProtocolo > 0) {
        wsGetMercadoPagoLaboratorio(
          turno.idProtocolo,
          !paciente ? -1 : paciente.id,
          nextStepMercadoPago,
        )(mercadoPagoDispatch);
      } else {
        wsGetMercadoPagoTurnos(
          turno.idturno,
          !paciente ? -1 : paciente.id,
          nextStepMercadoPago,
        )(mercadoPagoDispatch);
      }
    }
  };
  const refrescarTurnos = (isCorrect, data) => {
    if (isCorrect && data) {
      const turnosActualizados = actualizarTurnos(listTurnosSeleccionado, data);
      setTurnosSeleccionado(turnosActualizados)(turnosSeleccionadosDispatch);
      setLoadingGral(false);
    } else {
      setLoadingGral(false);
    }
  };

  const actualizarTurnos = (turnosLocal, turnosWs) => {
    return (turnosLocal ?? []).map((turnoLocal) => {
      const turnoWs = turnosWs?.find((t) => t.idturno === turnoLocal.idturno) ?? turnoLocal;
      if (turnoWs) {
        return { ...turnoLocal, ...turnoWs };
      }
      return turnoLocal;
    });
  };

  const irPuntoDeControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 8;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  let loopTurnoSaldado = () => {
    let count = 0;
    setLoading(true);
    let interval = setInterval(() => {
      let stopLoopTurnoSaldado = (isCorrect, flgSaldada) => {
        if (isCorrect && flgSaldada) {
          clearInterval(interval);
          setLoading(false);
          if (pasoState.circuito === "labo") {
            setPaso("CierreRecepcionLabo")(pasoDispatch);
          } else {
            const ruta = rutaState?.ruta?.data;
            setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
          }
        } else if (!isCorrect) {
          clearInterval(interval);
          irPuntoDeControl();
        }
      };
      if (pasoState.circuito === "labo") {
        wsGetTurnoSaldadoLabo(
          turno.idProtocolo,
          stopLoopTurnoSaldado,
        )(turnoSaldadoDispatch);
      } else {
        wsGetTurnoSaldado(
          turno.idturno,
          stopLoopTurnoSaldado,
        )(turnoSaldadoDispatch);
      }
      // 36 son 3 minutos
      count++;
      if (count >= 36) {
        setAvisoAutocheck(true)(avisoAutocheckDispatch);
        clearInterval(interval);
        mercadoPagoReset()(mercadoPagoDispatch);
        setPaso("Home")(pasoDispatch);
      }
    }, 5000);
    return interval;
  };

  const verMediosDePago = () => {
    stopInterval();
    localStorage.removeItem("mercadoPago");
    setLoading(false);
  };

  const pagarEfectivo = () => {
    setPaso("EfectivoMP")(pasoDispatch);
  };

  const handleClickVolver = () => {
    if (pasoState.circuito === "labo") {
      setPaso("TurnosDelDiaLabo")(pasoDispatch);
    } else {
      setPaso("TurnosDelDia")(pasoDispatch);
    }
  };

  const stopInterval = () => {
    if (intervalID) {
      clearInterval(intervalID); // Detiene el intervalo
      setIntervalID(null); // Limpia el ID del intervalo
    }
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    let interval;
    if (!initial && mercadoPagoState.mercadoPago.data) {
      interval = loopTurnoSaldado();
      setIntervalID(interval);
      try {
        const idWebservice = JSON.parse(
          mercadoPagoState.mercadoPago.data.idWebservice,
        );
        if (isIOS) {
          if (deviceType !== "web") {
            window.location.href = idWebservice.initPoint;
          } else {
            window.open(idWebservice.initPoint, "_blank");
          }
        } else {
          window.open(idWebservice.initPoint, "_blank");
        }
      } catch (e) {
        console.error("Error parsing idWebservice:", e);
      }
    } else if (mercadoPagoState.mercadoPago.data) {
      if (interval) {
        clearInterval(interval);
      }
      interval = loopTurnoSaldado();
    } else {
      setInitial(false);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [mercadoPagoState.mercadoPago.data, initial]);

  useEffect(() => {
    wsGetTurnosPacienteDelDia(
      idPacFamiliar,
      refrescarTurnos,
    )(turnosAutoCheckInDispatch);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={loadingGral}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {!loadingGral && (
        <LayoutPasos
          volverTo={"/autocheckin/resumen"}
          handleClick={() => {
            mercadoPagoReset()(mercadoPagoDispatch);
            handleClickVolver();
          }}
          type={"no-circle"}
          title={"Abonar MP"}
        >
          <CardBlueHeart
            medico={turno?.medico ? turno?.medico : turno?.especialidad}
            turnoTitle={turno?.especialidad}
            pasoActual={turnoActual + 1}
            pasoTotal={listTurnosSeleccionado?.length ?? 0}
          />
          <Paso4ContainerPaso>
            <PasoBar paso={"AbonarMP"} />
          </Paso4ContainerPaso>
          <Paso4Container
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <Paso4Titulo>
              <span className="rb18m">Pago</span>
            </Paso4Titulo>
            <hr className="ValidaTurno-separador"></hr>
            {loading ? (
              <>
                <div className={"loading-spinner-container"}>
                  <IonSpinner name="lines" />
                </div>
                <Paso4ContainerBotones>
                  <button
                    className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
                    onClick={verMediosDePago}
                  >
                    Volver a medios de pago
                  </button>
                </Paso4ContainerBotones>
              </>
            ) : (
              <>
                <Paso4Body>
                  <span className="ValidaTurno-bodytxt">{bodyTxt}</span>
                  <div className="ValidaTurno-montoMercadoPago">
                    <span className="rb48m">${turno?.resumen?.monto}</span>
                  </div>
                  <span className="ValidaTurno-bodytxt">{bodyTxt2}</span>
                </Paso4Body>
                <Paso4ContainerBotones>
                  <button
                    className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30"
                    onClick={handleClickMP}
                  >
                    <MercadoPagoLogo width={100} />
                  </button>
                  <button
                    className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
                    onClick={pagarEfectivo}
                  >
                    Efectivo
                  </button>
                </Paso4ContainerBotones>
              </>
            )}
          </Paso4Container>
        </LayoutPasos>
      )}
    </>
  );
};

export default AbonarMP;
